import type React from 'react'

import { themeTextColorMap } from '@mntn-dev/ui-theme'

import { cn } from '@mntn-dev/ui-utilities'
import { ListItem } from './list-item.tsx'

type ListProps = React.HTMLAttributes<HTMLUListElement>

const List = ({ className, ...props }: ListProps) => {
  return (
    <ul
      className={cn(
        'list-disc pl-6 text-sm',
        themeTextColorMap.primary,
        className
      )}
      {...props}
    />
  )
}

const ListNamespace = Object.assign(List, {
  Item: ListItem,
})

export { ListNamespace as List, type ListProps }
